import { render, staticRenderFns } from "./LiveChatMessage.vue?vue&type=template&id=690b89f1"
import script from "./LiveChatMessage.vue?vue&type=script&lang=ts"
export * from "./LiveChatMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports